import { Injectable } from '@angular/core';
import { GeneralService } from "./general-delete.service";
import { HttpClient } from "@angular/common/http";
import { StorageService } from "front-common-toolkits";
import { environment } from "../../environments/environment";
import { map, shareReplay } from "rxjs/operators";
import { Observable } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class SiteService extends GeneralService {
  loginType;
  constructor(
    public http: HttpClient,
    private storageService: StorageService
  ) {
    super(http);
    this.loginType = this.storageService.getLocalItem('loginType')
  }

  getMenusData() {
    this.loginType = this.storageService.getLocalItem('loginType') || 'tenant';
    let requestPath;
    const httpBase = environment.isAdmin ? environment.httpBase : environment.tenantHttpBase
    if (!environment.isAdmin) {
      const userId = this.storageService.getLocalItem('userId');
      requestPath = httpBase + '/ten/user/' + userId + '/menu';
    } else {
      const accountId = this.storageService.getLocalItem('accountId');
      requestPath = httpBase + '/adm/account/' + accountId + '/menu';
    }
    return this.http.get(requestPath).pipe(map(res => res['data']), shareReplay(1));
  }

  async getMenus() {
    let menuData = await this.getMenusData().toPromise();
    // 排除pc及移动端根目录菜单
    menuData = menuData.filter(o => o.menuId != 0 && o.menuId != 1 && o.menuId != 2)
    this.processMenuData(menuData);
    const menus = menuData.filter(m => m.level === 1);
    return menus;
  }
  defaultLoginMenu = null
  async getDefaultLoginMenu() {
    const menuData = await this.getMenus();
    console.log("get menuData", menuData);
    if (menuData && menuData.length > 0) {
      //20220306 baij 页面权限和路由配置第一个作为默认页面 导致可能无法跳转 
      this.getDeepDefaultMenu(menuData)
      return this.defaultLoginMenu
    } else {
      return null;
    }
  }
  //20220306 baij 前端快处理权限问题 
  getDeepDefaultMenu(menuData) {
    for (let i = 0; i < menuData.length; i++) {
      if (!menuData[i].disabled) {
        if (menuData[i].children && menuData[i].children.length > 0) {
          //并且子节点也都不等
          let index = menuData[i].children.findIndex(o => o.parentMenuId == menuData[i].menuId)
          if (index >= 0) {
            this.getDeepDefaultMenu(menuData[i].children)
            return false
          } else {
            this.defaultLoginMenu = menuData[i]
            return true
          }
        } else {
          this.defaultLoginMenu = menuData[i]
          return true
        }
      }
    }
  }

  private processMenuData(menuData) {
    if (menuData) {
      menuData.forEach(m => {
        this.processMenuChildren(m, menuData);
      })
      menuData.forEach(m => {
        this.processMenuLevel(m, menuData);
      })
    }
  }

  private processMenuChildren(currentMenu, menus) {
    const parentMenu = menus.find(m => m.menuId === currentMenu.parentMenuId);
    //组合父级加子级页面
    if (parentMenu) {
      //排除没有menuUrl的父页面（比如：pc端根菜单及mobile根菜单）
      if (parentMenu.menuUrl) {
        currentMenu.menuUrl = parentMenu.menuUrl + currentMenu.menuUrl;
      }
      if (!parentMenu.children) {
        parentMenu.children = [currentMenu];
      } else {
        parentMenu.children.push(currentMenu);
      }
    }
  }

  private processMenuLevel(currentMenu, menus) {
    if (!currentMenu.parentMenuId) {
      currentMenu.level = 1;
    } else {
      const parentMenu = menus.find(m => m.menuId === currentMenu.parentMenuId);
      if (parentMenu) {
        currentMenu.level = parentMenu.level + 1;
      }
    }
    if (currentMenu.children && currentMenu.menuId != 0 && currentMenu.menuId != 1) {
      currentMenu.children.forEach(m => this.processMenuLevel(m, menus))
    }
  }
  //关联方作为筛选条件：下拉加载项-无、客户、供应商 20220218 baij
  getByType(type) {
    return this.http.get(environment.tenantHttpBase + '/cms/phrase/' + type).pipe(map(res => res['data'] ? res['data'] : []));

  }

}
